// Phrase banks for floating text variety. Kept here so the main module isn't
// padded with literal arrays.

export const PHRASES = {
  perfectCenter: [
    'PERFECT HIT!',
    'CLEAN STRIKE!',
    'CENTER CUT!',
    'SWEET SPOT!',
    'LASER HANDS!',
  ],
  perfectEdge: [
    'EDGE SLING!',
    'WHIP SHOT!',
    'FULL SEND!',
    'ROCKET TAP!',
  ],
  combo5: [
    'CHAIN STARTED!',
    'KEEP IT HOT!',
    'SPARK STREAK!',
  ],
  combo15: [
    'NO BRAKES!',
    'STORM HANDS!',
    'YOU ARE COOKING!',
  ],
  combo30: [
    'INFINITE CHAIN!',
    'COMET RUN!',
    'NUCLEAR STREAK!',
  ],
  save: [
    'CLUTCH SAVE!',
    'NOT TODAY!',
    'STILL IN IT!',
    'GUARDIAN POP!',
  ],
  overdrive: [
    'OVERDRIVE!',
    'THE FLOOR IS LIGHT!',
    'COMET MODE!',
    'STARFALL!',
  ],
  missionStart: [
    'BOUNTY',
    'CONTRACT',
    'SPARK HUNT',
  ],
  missionDone: [
    'BOUNTY CLEARED!',
    'CONTRACT CASHED!',
    'SPARK CLAIMED!',
  ],
  highScore: [
    'NEW LEGEND!',
    'TOP RUN!',
    'HALL OF SPARKS!',
  ],
  waveClear: [
    'WAVE BROKEN!',
    'STORM CLEARED!',
    'CRESTED!',
  ],
  pulse: [
    'PULSE SHOT!',
    'BEAM FIRED!',
    'CHARGED CUT!',
  ],
  bountyBrick: [
    'BOUNTY!',
    'GOLD STRIKE!',
    'SPARK CORE!',
  ],
} as const;

export function pickPhrase(list: readonly string[]): string {
  return list[(Math.random() * list.length) | 0] ?? list[0] ?? '';
}
